import { FC, useContext, useEffect, useRef, useState } from "react"
import { IAsset, IAssetCreate, RequiredFields } from "../../models"
import Context from "../../../../common/components/utils/context"
import { notifcation } from "../../../../common/components/utils/notifications"
import { IModal } from "../../../../common/components/modal/modal"

export const AssetEdit: FC<IEditAsset> = (data) => {

    const context = useContext(Context)

    const form = useRef(null)

    const [create, setCreate] = useState<boolean>(true)
    const [fields, setFields] = useState<IAsset>(data ?? {} as IAsset)
    const [valid, setValid] = useState<boolean>(false)

    useEffect(() => {
        data.id && setCreate(false)
        if (!data.id) {
            setFields({...fields,
                description: "",
                manufacturer: "",
                model: "",
                serialNumber: "",
                yearManufactured: +"",
                registrationNumber: "", 
                systemLink: "",
                other: ""
            })
        }
    }, [data])

    useEffect(() => {
        setValid(validate(fields))
    }, [fields])

    const validate = (input: any): input is RequiredFields<IAssetCreate> => {
        const schema: Record<keyof RequiredFields<IAssetCreate>, string> = {
            description: 'string'
        }
        const missing = Object
            .keys(schema)
            .filter(key => input[key] === "")
            .map(key => key as keyof RequiredFields<IAssetCreate>)

        return missing.length === 0
    }

    const reset = () => {
        setFields(data)
        context.setModal({...{} as IModal})
    }

    const cancel = async () => {
        if (fields !== data) {
            const confirm = await notifcation({
                title: "Cancel",
                message: "Unsaved changes will be lost.",
                cancel: "Go Back",
                confirm: "Confirm Cancel"
            })
            if (confirm) {
                reset()
            }
        } else {
            reset()
        }
    }

    const save = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        data.save?.(fields)
        reset()
    }

    return (
        <div className="bg-white rounded-lg mx-auto px-5 py-8">
            <div className="grid grid-flow-col space-x-4">
                <h2 className="text-xl font-medium">{create ? 'Create' : 'Update'}</h2>
                <div className="flex justify-end">
                    <div className="inline-flex items-center overflow-hidden rounded-lg border border-stroke dark:border-dark-3">
                        {/*
                        <button disabled={isDisabled} hidden={!canlocate} className={`border-r px-3 py-2 last-of-type:border-r-0 ${location ? 'bg-gray-100 shadow-inner' : 'hover:bg-gray-50'}`} onClick={() => setLocation(!location)}>
                            {isDisabled 
                                ? <Circles height="20" width="20" color="#2DE1FC" />
                                : location 
                                    ? <TbCurrentLocation className="text-logo" size={20} />
                                    : <TbCurrentLocationOff size={20} />
                            }
                        </button>
                        */}
                    </div>
                </div>
            </div>
            <form onSubmit={save} ref={form} className="flex flex-col space-y-5 justify-center items-center">
                <fieldset className="w-full">
                    <label htmlFor="description" className="text-gray-500 text-sm">
                        Description*
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="description"
                        value={fields.description}
                        onChange={(e) => setFields({ ...fields, description: e.target.value })}
                        required
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="manufacturer" className="text-gray-500 text-sm">
                        Manufacturer
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="manufacturer"
                        value={fields.manufacturer}
                        onChange={(e) => setFields({ ...fields, manufacturer: e.target.value })}
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="model" className="text-gray-500 text-sm">
                        Model
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="model"
                        value={fields.model}
                        onChange={(e) => setFields({ ...fields, model: e.target.value })}
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="yearManufactured" className="text-gray-500 text-sm">
                        Year Manufactured
                    </label>
                    <input
                        type="number"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="yearManufactured"
                        value={fields.yearManufactured}
                        onChange={(e) => setFields({ ...fields, yearManufactured: +e.target.value })}
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="serialNumber" className="text-gray-500 text-sm">
                        Serial Number
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="serialNumber"
                        value={fields.serialNumber}
                        onChange={(e) => setFields({ ...fields, serialNumber: e.target.value })}
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="registrationNumber" className="text-gray-500 text-sm">
                        Registration Number
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="registrationNumber"
                        value={fields.registrationNumber}
                        onChange={(e) => setFields({ ...fields, registrationNumber: e.target.value })}
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="systemLink" className="text-gray-500 text-sm">
                        ERP Asset System link
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="systemLink"
                        value={fields.systemLink}
                        onChange={(e) => setFields({ ...fields, systemLink: e.target.value })}
                    />
                </fieldset>
                <fieldset className="w-full">
                    <label htmlFor="other" className="text-gray-500 text-sm">
                        Other
                    </label>
                    <input
                        type="text"
                        className="block w-full bg-gray-50 outline-none border-b py-2 px-4"
                        name="other"
                        value={fields.other}
                        onChange={(e) => setFields({ ...fields, other: e.target.value })}
                    />
                </fieldset>
                <div className="grid grid-flow-col justify-end space-x-4">
                    <button type="button" onClick={cancel} className="transition-all rounded-lg text-gray-800 text-sm tracking-wider font-medium outline-none bg-gray-100 hover:bg-gray-200 px-10 py-2">
                        Cancel
                    </button>
                    <button type="submit" disabled={!valid} className={`transition-all rounded-lg ${!valid ? 'opacity-25' : 'hover:text-white text-gray-800'} text-sm tracking-wider font-medium outline-none bg-text-link px-10 py-2`}>
                        {create ? 'Create' : 'Update'}
                    </button>
                </div>
            </form>
        </div>
    )
}

export interface IEditAsset extends IAsset {
    save: (item: IAsset) => void
}